import BossModel from "@/models/BossModel";
import ExchangeRate from '@/models/ExchangeRate/ExchangeRate'
import Purchase from "@/models/Product/Detail/Composition/Purchase/Purchase";

export default class Currency extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'currency';

    /**
     *
     * @type {string}
     */
    static entity = 'currencies';

    static fields() {
		return {
			id: this.attr(null),
			name: this.attr(null),
			code: this.attr(null),
			is_active: this.attr(null),
			updated_at: this.attr(null),
			sort_order: this.attr(null),
            purchases: this.hasMany(Purchase, 'currency_id'),
		}
	}

    /**
     *
     * @param date
     * @returns {Promise<unknown>}
     */
    getRateByDate(date) {
        return ExchangeRate.findOrLoadByDateAndCurrency(this.id, date).then((result) => {
            return result;
        });
    }

    /**
     *
     * @returns {*}
     */
    static loadAll() {
        return this.api()
            .limit(0)
            .get(true);
    }

    /**
     *
     * @param agentId
     * @returns {PromiseLike<[]> | Promise<[]> | *}
     */
    static fetchByAgent(agentId) {
        return this.api()
            .limit(0)
            .where('agent_id',agentId).get().then((response) => {
            let currencies = [];
            for(let key in response) {
                currencies.push(new Currency(response[key]));
            }
            return currencies;
        });
    }

    static fetchRates() {
        return this.api().action('rates').get();
    }

    static fetchByAgentCode(agentCodeId) {
        return this.api()
            .limit(0)
            .where('agent_code_id',agentCodeId)
            .with('currentExchangeRate')
            .get().then((response) => {
                let currencies = [];
                for(let key in response) {
                    currencies.push(new Currency(response[key]));
                }
                return currencies;
            });
    }
}
